cplook = require('cplook')
_ = require('underscore');
pageTop = 0

onResize = (app) ->
  window.requestAnimationFrame ->
    pageTop = 0
    footer = 0
    $('.navbar-fixed-top').each ->
      pageTop = pageTop + $(this).outerHeight()
    $('.footer').each ->
      footer = footer + $(this).outerHeight()
    data =
      screenWidth: Math.round($(window).width())
      scrollTop: Math.round($(window).scrollTop())
      appTop: Math.round(app.cp_jq.offset().top)
      appMaxHeight: Math.round($(window).height()) - Math.round(pageTop) - Math.round(footer)
      appWidth: Math.round(app.cp_jq.width())
      pageTop: Math.round(pageTop)
      pageHeight: Math.round(app.cp_jq.find('.pdf-view .page:first').height())
      pageWidth: Math.round(app.cp_jq.find('.pdf-view .page:first').width())
    app.ports.pdfResult.send
      tag: 'Measure'
      data: data

handleCmd = (opts) ->
  app = this
  if opts.tag == 'ScrollTop' && opts.data?
    window.requestAnimationFrame ->
      app.cp_jq.find(opts.data.name).animate({ scrollTop: opts.data.scrollY })
  else if opts.tag == 'ScrollWindowTo' && opts.data?
    window.requestAnimationFrame ->
      offset = if pageTop > 0 then pageTop else 100
      element = $(opts.data.name)
      return if element.length == 0
      scrollY = element.offset().top - offset
      $(window).animate(
        { scrollTop: scrollY }
        , ->
          element.focus()
      )
  else if opts.tag == 'SubmitForm'
    window.requestAnimationFrame ->
      app.cp_jq.closest('form').off 'submit'
      app.cp_jq.closest('form').submit()
  else if opts.tag == 'Measure'
    todo = opts.data.length
    doload = ->
      todo--
      if todo < 1
        onResize(app)
    doimg = (src) ->
      img = new Image()
      img.addEventListener('load', doload)
      img.src = src
    doimg i for i in opts.data
  else if opts.tag == 'Signature'
    el = $(opts.data)
    el.signaturePad
      bgColour: '#fff'
      lineTop: Math.round(el.find('canvas').height() * 0.8)
      drawOnly: true
      validateFields: false
      penColour: '#333'
    el.find('.nav-tabs').tab()
  else
    console.log ["Received unknown message from app", opts]

module.exports = (opts) ->
  if opts.PdfForm?
    target = '.pdf_form_app'
    elmClass = 'PdfForm'
    elm = opts
  else
    target = opts.target
    elmClass = opts.elmClass
    elm = opts.elm
  $ ->
    $(target).each ->
      el = $(this)
      el.closest('form').on 'submit', (ev) ->
        ev.preventDefault()
        false
      opts = el.data()
      opts.mobilePivot = [cplook.default.mobilePivot, Math.round($(window).width())]
      opts.pointerEvent = window.PointerEvent?
      app = elm[elmClass].embed(el.get()[0], el.data())
      app.cp_jq = el
      app.ports.pdfCmd.subscribe handleCmd.bind(app)
      $(window).resize onResize.bind(null, app)
      # If the window width is larger than the default mobile pivot, set resize function
      if opts.mobilePivot[1] >= opts.mobilePivot[0]
        $(window).scroll _.debounce(onResize.bind(null, app), 15)

